export default __webpack_public_path__ + "static/media/telegramIcon.a674bb7a.svg";